function isEmpty(value) {
    return value === undefined || value === null;
}
export { isEmpty };
//# sourceMappingURL=index.js.map